import React from "react";
import CallAPI from "../../../../adminpanel/components/commonComponents/AxiosHelper";

const formUpload = {
    "fixDataForm": {
        "virtualTableName": {
            "name": "virtualTableName", "label": "Enter New Table Name", "type": "hide", "requiredFlag": true
        },
        "allColumnSize": {
            "name": "allColumnSize", "label": "Set New Column Size", "type": "hide", "requiredFlag": true
        },
        "sheetName": {
            "name": "sheetName", "label": "Enter New Sheet Name", "type": "hide", "requiredFlag": true
        },
        "overwriteType": {
            "name": "overwriteType", "label": "Overwrite Action", "type": "hide", "text_value": "", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Overwrite entire table", "value": 'full' },
                { "name": "Overwrite data for file", "value": "file" }
            ], "requiredFlag": true
        },
        "fileName": {
            "name": "fileName", "label": "Select File", "type": "hide", "options": [], "requiredFlag": false,
        },
        "dateColumn": {
            "name": "dateColumn", "label": "Selected Date Column", "text_value": "", "type": "hide", "requiredFlag": true, "disabled": true,
        },
        "startDate": {
            "name": "startDate", "label": "Start Date", "type": "hide", "requiredFlag": false,
        },
        "endDate": {
            "name": "endDate", "label": "End Date", "type": "hide", "requiredFlag": false,
        },
        "dataset": {
            "name": "dataset", "label": "Data", "type": "hide", "id": "createFile", "requiredFlag": true
        }
    }
}

const modalConfig = {
    "fixDataModal": {
        "id": "fixDataModal", "form_name": "fixData", "form_id": "fixDataForm", "title": "Fix Data", "body": null, "button_name": "Update", buttonType: "submit", "display": true
    },
}

export function FixModal(row, setmodalToView, setdataToSend) {
    let formData = JSON.parse(JSON.stringify(formUpload['fixDataForm']));
    let config = JSON.parse(JSON.stringify(modalConfig['fixDataModal']));
    let fix_info = [];

    fix_info = JSON.parse(row.post_body);
    fix_info['request_id'] = row.id;
    fix_info['api_request'] = true;
    fix_info['rm_backend_process'] = 1;
    delete fix_info['pull_information'][0]['file']

    if (row.error_code === "620") {
        delete fix_info['pull_information'][0]['targetTable']
        formData["virtualTableName"]['type'] = "text";
    } else if (row.error_code === "611") {
        formData["allColumnSize"]['type'] = "number";
    } else if (row.error_code === "622") {
        formData["sheetName"]['type'] = "text";
    } else if (row.error_code === "615") {
        let dateColumnSelected = null;
        if (JSON.parse(row['post_body']).pull_information[0].connection_type !== "manual") {
            formData['overwriteType']['type'] = "dropdown";
            formData['dateColumn']['type'] = "text";
            dateColumnSelected = JSON.parse(row['post_body']).pull_information[0].dateColumn;
            formData['dateColumn']['text_value'] = dateColumnSelected
            formData['startDate']['type'] = "date"
            formData['startDate']['text_value'] = null;
            formData['endDate']['type'] = "date"
            formData['endDate']['text_value'] = null;
            formData['dataset']['type'] = "hide";
        } else {
            formData['overwriteType']['type'] = "dropdown";
            formData['dateColumn']['type'] = "hide";
            formData['startDate']['type'] = "hide";
            formData['endDate']['type'] = "hide";
            formData['dataset']['type'] = "newFile";
        }
        //fix_info['pull_information'][0]["overwriteCondition"] = { "fileName": [JSON.parse(row['post_body']).pull_information[0].fileName] };
        //fix_info['pull_information'][0]["action"] = "overwrite";
    }
    setdataToSend(fix_info)
    config['formKey'] = `fixDataForm_${Math.floor(Math.random() * 10)}`;
    config['isLoading'] = false;
    setmodalToView({ modal: config, formData: formData });
    setTimeout(() => {
        jQuery('#fixDataModal').modal('toggle');
    }, 5);
}

const getOverwriteOptions = (tableName, connectionId, setmodalToView, modalToView, authData) => {
    let tempFormData = { ...modalToView };
    let params = { "siteId": authData.siteId, "tableName": tableName, "connectionId": connectionId };

    CallAPI('get', '/app/get_pulled_file_list', null, params, 0, function (response) {
        let fileOptions = [{ "name": "Select Option", "value": "" }];
        if (response.status === true) {
            response.information.fileInfo.map(function (innerData) {
                if (innerData['data_summary'] == 1)
                    fileOptions.push({ 'name': innerData.fileName, 'value': innerData.fileName });
            })
        }
        if (fileOptions.length === 1) {
            fileOptions.push({ "name": "No more successful files in this table", "value": "" })
        }
        tempFormData.formData['fileName']['options'] = fileOptions;
        tempFormData.modal['formKey'] = `fixDataFormForm_${Math.floor(Math.random() * 10)}`;
        setmodalToView(tempFormData);
    }, authData)
}

export function FixModalDropDownEvent(e, dataToSend, modalToView, setmodalToView, authData) {
    let tempFormData = modalToView.formData;
    tempFormData[e.target.name].text_value = e.target.value;
    if (e.target.name == "overwriteType") {
        if (e.target.value == "file") {
            let tableName = dataToSend['pull_information'][0]['targetTable'];
            let connectionId = dataToSend['pull_information'][0]['connectionId'];
            getOverwriteOptions(tableName, connectionId, setmodalToView, modalToView, authData)
            tempFormData['fileName']['type'] = "dropdown"
        } else {
            tempFormData['fileName']['type'] = "hide"
        }
    }
    let tempModal = modalToView.modal;
    tempModal['formKey'] = `fixDataForm_${Math.floor(Math.random() * 10)}`;
    setmodalToView({ ...modalToView, formData: tempFormData, modal: tempModal });
}